module.exports = __webpack_public_path__ + "img/terminal-fill.9c2e58d2.svg";